import React, {useContext} from 'react';
import {
	Avatar,
	Badge,
	Button,
	CardActionArea,
	CardContent,
	CardHeader,
	Chip,
	Divider,
	Typography
} from "@mui/material";
import moment from "moment";
import {getDataLabel} from "../../../../utils/TableUtils";
import Tooltip from "@mui/material/Tooltip";
import {amber, blue, brown, deepPurple, green, orange, red, teal} from "@mui/material/colors";
import FaceTwoToneIcon from '@mui/icons-material/FaceTwoTone';
import VerifiedUserTwoToneIcon from '@mui/icons-material/VerifiedUserTwoTone';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import RemoveTwoToneIcon from '@mui/icons-material/RemoveTwoTone';
import HelpOutlineTwoToneIcon from '@mui/icons-material/HelpOutlineTwoTone';
import multiavatar from "@multiavatar/multiavatar";
import SVG from "react-inlinesvg";
import {setOpenSnackbar} from "../../../../services/AppServices";
import {calculateAge, capitalizeWords} from "../../../../utils/GenericUtils";
import {useTheme} from "@mui/styles";
import {AppContext} from "../../../../App";
import SmsTwoToneIcon from '@mui/icons-material/SmsTwoTone';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined';

const TamponeCard = ({tampone, onClickTampone, setValue}) => {
	const theme = useTheme();
	const appContext = useContext(AppContext);
	
	return (
        <React.Fragment>
            <Tooltip
				title={"Clicca per gestire: intervistare o prendere in carico in caso il paziente non sia disponibile"}>
				<CardActionArea onClick={() => onClickTampone(tampone)}>
					<CardHeader
						style={{paddingBottom: 2}}
						avatar={
							<Badge
								color={"secondary"}
								badgeContent={tampone.stato === "Da gestire" ? "DG" : tampone.stato === "Gestito" ? "GG" : "P"}
								anchorOrigin={{
									vertical: 'bottom',
									horizontal: 'right',
								}}
							>
								<Avatar>
									<SVG src={multiavatar(tampone?.codF)}/>
								</Avatar>
							</Badge>
						}
						action={
							<Typography
								style={{display: "flex", alignItems: "center"}}
								variant={"body2"}
								color={"textSecondary"}>Data
								esito: {tampone.dataEsito ? moment(tampone.dataEsito).format("DD/MM/YYYY HH:mm  ") : "--"}</Typography>
						}
						title={
							<Typography variant={"subtitle1"} style={{position: "relative"}}>
								<b>{tampone.testTipoDesc}</b> - {tampone.esitoTampone}
							</Typography>
						}
						subheader={
							tampone.active ?
								<Typography variant={"body2"} color={"textSecondary"}>
									Ticket con stato <b>{tampone.stato}</b> attualmente in gestione da parte
									di <b>{tampone.lastModify}</b>
								</Typography> :
								<Typography variant={"body2"} color={"textSecondary"}>
									Ultima modifica: <b>{getDataLabel(tampone.dataUltimaModifica)}</b> da parte
									di <b>{tampone.lastModify}</b>
								</Typography>
						}
					/>
					<CardContent style={{paddingTop: 8}}>
						<div style={{display: "flex"}}>
							<Tooltip title={"Clicca per copiare"}>
								<Button variant={"text"}
								        style={{padding: 2, color: theme.palette.text.secondary, textTransform: "none"}}
								        component={"div"}
								        onClick={(event) => {
									        event.stopPropagation();
									        navigator?.clipboard?.writeText(tampone.id).then(() => {
										        setOpenSnackbar("info", "ID copiato negli appunti", appContext.dispatch);
									        })
								        }}>
									<b>{"ID: " + tampone.id}</b>
								</Button>
							</Tooltip>
							<Divider orientation={"vertical"}
							         style={{height: 16, marginLeft: 10, marginRight: 10, alignSelf: "center"}}/>
							<Tooltip title={"Clicca per copiare"}>
								<Button variant={"text"}
								        style={{padding: 2, color: theme.palette.text.secondary, textTransform: "none"}}
								        component={"div"}
								        onClick={(event) => {
									        event.stopPropagation();
									        navigator?.clipboard?.writeText(tampone.soggetto?.codF).then(() => {
										        setOpenSnackbar("info", "Documento copiato negli appunti", appContext.dispatch);
									        })
								        }}>
									{
										tampone.soggetto?.codF === "UTENTE_ANONIMO" ? <b>Utente anonimo</b> :
											<b>{
												"Codice fiscale: " + (tampone.soggetto.codF) + ", " + capitalizeWords(tampone.soggetto?.nome) + " " + capitalizeWords(tampone.soggetto?.cognome)}
												{
													tampone.soggetto?.dataNascita ? (", " + calculateAge(tampone.soggetto.dataNascita) + " anni") : ""
												}
											</b>
									}
								</Button>
							</Tooltip>
							<Divider orientation={"vertical"}
							         style={{height: 16, marginLeft: 10, marginRight: 10, alignSelf: "center"}}/>
							<Typography variant={"body2"} color={"textSecondary"} style={{alignSelf: "center"}}>
								{tampone.indirizzoAssociato}
							</Typography>
						</div>
						<Typography variant={"body2"} color={"textSecondary"}>
							Laboratiorio: <i>{tampone.laboratorio}</i> - Medico
							richiedente:<i>{tampone.medicoRichiedente}, {tampone.contattoRichiedente}</i><br/>
							Criterio epidemiologico: <i>{tampone.criterioEpidemiologico}</i>,
							Motivazione: <i>{tampone.motivazione}</i>
						</Typography>
						{
							tampone.comunicazioni &&
							<Chip label={tampone.comunicazioni}
							      avatar={<Avatar style={{backgroundColor: deepPurple[700], color: "#FFF"}}>
								      <SmsTwoToneIcon style={{fontSize: 18}}/>
							      </Avatar>} style={{
								marginRight: 8,
								marginTop: 8,
								backgroundColor: deepPurple[500],
								color: "#FFF"
							}}/>
						}
						{
							tampone.statoTampone &&
							<Chip label={tampone.statoTampone}
							      avatar={<Avatar style={{backgroundColor: teal[700], color: "#FFF"}}>
								      <CheckCircleOutlineIcon style={{fontSize: 18}}/>
							      </Avatar>} style={{
								marginRight: 8,
								marginTop: 8,
								backgroundColor: teal[500],
								color: "#FFF"
							}}/>
						}
						{
							tampone.note && tampone.note.replaceAll(/#(\S*)/g, "").length > 1 &&
							<Typography variant={"body2"} color={"primary"}>
								<b>NOTE:</b> {tampone.note.replaceAll(/#(\S*)/g, "")}
							</Typography>
						}
						{
							tampone.descTipoSoggetto &&
							<Chip label={tampone.descTipoSoggetto.toUpperCase()}
							      clickable
							      onClick={(event) => {
								      event.stopPropagation();
								      setValue(tampone.descTipoSoggetto);
							      }}
							      avatar={<Avatar style={{backgroundColor: amber[700]}}><FaceTwoToneIcon
								      style={{color: "#000"}}/></Avatar>} style={{
								marginRight: 8,
								marginTop: 8,
								backgroundColor: amber[500],
								color: "#000"
							}}/>
						}
						{
							tampone.tamponeAutorizzato &&
							<Chip label={"TAMPONE AUTORIZZATO"}
							      avatar={<Avatar style={{backgroundColor: blue[700]}}><VerifiedUserTwoToneIcon
								      style={{color: "#000"}}/></Avatar>} style={{
								marginRight: 8,
								marginTop: 8,
								backgroundColor: blue[500],
								color: "#000"
							}}/>
						}
						{
							tampone.esitoTampone === "POSITIVO" &&
							<Chip label={"POSITIVO"}
							      avatar={<Avatar style={{backgroundColor: red[700]}}><AddTwoToneIcon
								      style={{color: "#000"}}/></Avatar>} style={{
								marginRight: 8,
								marginTop: 8,
								backgroundColor: red[500],
								color: "#000"
							}}/>
						}
						{
							tampone.esitoTampone === "NEGATIVO" &&
							<Chip label={"NEGATIVO"}
							      avatar={<Avatar style={{backgroundColor: green[700]}}><RemoveTwoToneIcon
								      style={{color: "#000"}}/></Avatar>} style={{
								marginRight: 8,
								marginTop: 8,
								backgroundColor: green[500],
								color: "#000"
							}}/>
						}
						{
							tampone.esitoTampone !== "NEGATIVO" && tampone.esitoTampone !== "POSITIVO" &&
							<Chip label={tampone.esitoTampone === "N/D" ? "NON DICHIARATO" : tampone.esitoTampone}
							      avatar={<Avatar style={{backgroundColor: orange[700]}}><HelpOutlineTwoToneIcon
								      style={{color: "#000"}}/></Avatar>} style={{
								marginRight: 8,
								marginTop: 8,
								backgroundColor: orange[500],
								color: "#000"
							}}/>
						}
						{
							tampone.criterioEpidemiologico?.includes("stretto") &&
							<Chip label={"CONTATTO STRETTO"}
							      clickable
							      onClick={(event) => {
								      event.stopPropagation();
								      setValue("Contatto stretto");
							      }}
							      avatar={<Avatar style={{backgroundColor: green[700], color: "#FFF"}}>#</Avatar>} style={{
								marginRight: 8,
								marginTop: 8,
								backgroundColor: green[500],
								color: "#000"
							}}/>
						}
						{
							tampone.criterioEpidemiologico?.includes("asintomatico") &&
							<Chip label={"ASINTOMATICO"}
							      clickable
							      onClick={(event) => {
								      event.stopPropagation();
								      setValue("asintomatico");
							      }}
							      avatar={<Avatar style={{backgroundColor: brown[700], color: "#FFF"}}>#</Avatar>} style={{
								marginRight: 8,
								marginTop: 8,
								backgroundColor: brown[500],
								color: "#FFF"
							}}/>
						}
						{
							tampone.criterioEpidemiologico?.includes("Sintomatico") && !tampone.criterioEpidemiologico?.includes("asintomatico") &&
							<Chip label={"SINTOMATICO"}
							      clickable
							      onClick={(event) => {
								      event.stopPropagation();
								      setValue("Sintomatico");
							      }}
							      avatar={<Avatar style={{backgroundColor: red[700], color: "#FFF"}}>#</Avatar>} style={{
								marginRight: 8,
								marginTop: 8,
								backgroundColor: red[500],
								color: "#000"
							}}/>
						}
						{
							tampone.note && tampone.note.match(/#(\S*)/g)?.map(item => {
								return (
									<Tooltip key={item} title={"Clicca per cercare tramite #hastag"}>
										<Chip
											clickable
											onClick={(event) => {
												event.stopPropagation();
												setValue(item.replace(" ", ""));
											}}
											label={item.substring(1)}
											avatar={<Avatar><b>#</b></Avatar>}
											color={"secondary"}
											style={{
												marginRight: 8,
												marginTop: 8,
											}}/>
									</Tooltip>
								)
							})
						}
					</CardContent>
				</CardActionArea>
			</Tooltip>
        </React.Fragment>
    );
}

export default React.memo(TamponeCard)
